const baseStyle = {
  width: 'auto',
  height: 'auto',
  display: 'flex',
  flexDirection: 'row',
};
const defaultProps = {
  direction: 'row',
  wrap: 'wrap',
};

export default {
  baseStyle,
  defaultProps,
};
